"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ruleMatchChoices = [
    {
        action: 'continue',
        label: '(Text) Contains',
        match: 'icontains',
    },
    {
        action: 'stop',
        label: '(Text) Does not contain',
        match: 'icontains',
    },
    {
        action: 'continue',
        label: '(Text) Exactly matches',
        match: 'iexact',
    },
    {
        action: 'stop',
        label: '(Text) Does not exactly match',
        match: 'iexact',
    },
    {
        action: 'continue',
        label: '(Text) Is in',
        match: 'ireversecontains',
    },
    {
        action: 'stop',
        label: '(Text) Is not in',
        match: 'ireversecontains',
    },
    {
        action: 'continue',
        label: '(Text) Starts with',
        match: 'istartswith',
    },
    {
        action: 'stop',
        label: '(Text) Does not start with',
        match: 'istartswith',
    },
    {
        action: 'continue',
        label: '(Text) Ends with',
        match: 'iendswith',
    },
    {
        action: 'stop',
        label: '(Text) Does not end with',
        match: 'iendswith',
    },
    {
        action: 'continue',
        label: '(Number) Greater than',
        match: 'igreater',
    },
    {
        action: 'continue',
        label: '(Number) Less than',
        match: 'iless',
    },
    {
        action: 'continue',
        label: '(Date/time) After',
        match: 'idategreater',
    },
    {
        action: 'continue',
        label: '(Date/time) Before',
        match: 'idateless',
    },
    {
        action: 'continue',
        label: '(Date/time) Equals',
        match: 'idateequal',
    },
    {
        action: 'continue',
        label: '(Boolean) Is true',
        match: 'boolean',
    },
    {
        action: 'stop',
        label: '(Boolean) Is false',
        match: 'boolean',
    },
    {
        action: 'continue',
        label: 'Exists',
        match: 'iexist',
    },
    {
        action: 'stop',
        label: 'Does not exist',
        match: 'iexist',
    },
];
exports.default = ruleMatchChoices;
